import { render, staticRenderFns } from "./LazyClientShow.vue?vue&type=template&id=59275937&scoped=true"
import script from "./LazyClientShow.vue?vue&type=script&lang=ts&setup=true"
export * from "./LazyClientShow.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LazyClientShow.vue?vue&type=style&index=0&id=59275937&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59275937",
  null
  
)

export default component.exports